import React from "react";
import MFrame from "@/components/ui/atoms/MFrame";
import MSelectCard from "@/components/ui/atoms/MSelectCard";

const options = [
  { label: "Option 1", value: "1" },
  { label: "Option 2", value: "2" },
  { label: "Option 3", value: "3" },
];

const MFrameTest: React.FC = () => {
  const [selected, setSelected] = React.useState<string | null>(null);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f6f8fa" }}>
      <MFrame>
        
          {options.map((option) => (
            <MSelectCard
              key={option.value}
              text={option.label}
              selected={selected === option.value}
              onClick={() => setSelected(option.value)}
              style={{ cursor: 'pointer', width: '100%', minWidth: 0 }}
            />
          ))}
       
        {selected && (
          <div style={{ marginTop: 24, fontWeight: 500, color: '#2A2A2A' }}>
            Selected: {options.find((o) => o.value === selected)?.label}
          </div>
        )}
      </MFrame>
    </div>
  );
};

export default MFrameTest;
